import { type FC, useEffect, useState } from 'react';

import ColorPickerDropdown from './ColorPickerDropdown';
import { colorCell } from './styles';

interface Props {
	defaultColor: string;
	index: number;
	onChange: (_) => void;
}

const ColorPicker: FC<Props> = (props) => {
	const { defaultColor, index, onChange } = props;

	const [color, setColor] = useState(defaultColor);
	const [coords, setCoords] = useState({ top: 0, left: 0 });
	const [showColorPicker, setShowColorPicker] = useState(false);

	useEffect(() => {
		if (defaultColor !== color) {
			setColor(defaultColor);
		}
	}, [defaultColor]);

	const handleColorPickClick = (e) => {
		const rect = e.target.getBoundingClientRect();

		setCoords({ left: rect.x, top: rect.y + rect.height + window.scrollY });
		setShowColorPicker(!showColorPicker);
	};

	const onColorChange = (value) => {
		setColor(value);
		onChange({ index, value });
	};

	const onClickOutside = () => {
		setShowColorPicker(false);
	};

	return (
		<>
			<div className={colorCell}>
				<div
					className="colorSquare"
					style={{ backgroundColor: color }}
					onClick={handleColorPickClick}
				/>

				<span>{defaultColor}</span>

				{showColorPicker && (
					<ColorPickerDropdown
						defaultColor={color}
						coords={coords}
						onChangeComplete={onColorChange}
						onClickOutside={onClickOutside}
					/>
				)}
			</div>
		</>
	);
};

export default ColorPicker;
